/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 *
 * @author Nikolay Sviridov
 * @version 1.35.0
 * @since 1.35.0
 */

import type { FC, ReactElement } from 'react';

import { Tooltip } from '@nexign/scc-ui-kit';

import {
	RoamingOptionCardServiceDescriptionStyled,
	RoamingOptionTypographyStyled,
	FootnoteTypographyStyled,
} from '../styled/RoamingOptionsStyled';

interface IRoamingOptionServiceDescription {
	footnoteTooltip: string | ReactElement;
	iconUrl: string;
	defaultIcon: string;
	title: string;
	isTitleBold?: boolean;
}

export const RoamingOptionVolumeDescription: FC<IRoamingOptionServiceDescription> = ({
	footnoteTooltip,
	iconUrl,
	defaultIcon,
	title,
	isTitleBold = false,
}) => {
	const footnoteTooltipStyled = footnoteTooltip ? (
		<FootnoteTypographyStyled>{footnoteTooltip}</FootnoteTypographyStyled>
	) : (
		''
	);
	return (
		<Tooltip
			arrow
			body={footnoteTooltipStyled}
			maxWidth={400}
			placement='bottom'
		>
			<RoamingOptionCardServiceDescriptionStyled>
				<img
					alt='volumeIcon'
					height='20px'
					src={iconUrl || defaultIcon}
					width='20px'
				/>
				<RoamingOptionTypographyStyled
					component='span'
					isdashedunderline={footnoteTooltip}
					variant={isTitleBold ? 'body1bold' : 'body1'}
				>
					{title}
				</RoamingOptionTypographyStyled>
			</RoamingOptionCardServiceDescriptionStyled>
		</Tooltip>
	);
};
